import AKJS from "@akc/akjs";
import { useUnmount } from "ahooks";
import { useEffect, useRef } from "react";
import { platform } from "./platform";
export const onClosePage = (options?: {
  appOptions?: {
    markId: string;
  };
}) => {
  const { isApp } = platform;
  if (isApp) {
    AKJS.ready().then(() => {
      AKJS.action.dispatch("event.page.close", options?.appOptions);
    });
  } else {
    history.back();
  }
};

export const setMarkPageId = (options?: {
  appOptions?: {
    markId: string;
  };
}) => {
  const { isApp } = platform;
  if (isApp) {
    AKJS.ready().then(() => {
      AKJS.action.dispatch("event.page.setMarkId", options?.appOptions);
    });
  }
};

export const usePageTitle = (title: string) => {
  const originalTitle = useRef(document.title);
  useEffect(() => {
    document.title = title;
  }, [title]);

  useUnmount(() => {
    document.title = originalTitle.current;
  });
};
